//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Site guids */
export const Site = {
    /** The check in manager site guid */
    CheckInManager: "A5FA7C3C-A238-4E0B-95DE-B540144321EC",
    /** Gets the External Site guid. */
    ExternalSite: "F3F82256-2D66-432B-9D67-3552CD2F4C2B",
    /** Gets the default Rock Site guid */
    SiteRockInternal: "C2D29296-6A87-47A9-A753-EE4E9159C4C4",
};
